import { TeamMember } from '../models';
import { TeamRepository } from '../repositories';

export class GetTeamMembersUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(teamId: string): Promise<TeamMember[]> {
    return this.teamRepository.getMembers(teamId);
  }
}
